import React from "react";
import moment from "moment";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import {
  DURATION_UNIT_LIST,
  ORDER_STATUS,
  PAYMENT_TYPE,
} from "constants/global";
import { StyledOrderDetail } from "./Order.style";

const OrderDetail = ({ order, subscriptionProduct, closeOrderDetail }) => {
  const productName =
    (subscriptionProduct || []).find((item) => item.code === order.productCode)
      ?.name ||
    order.productCode ||
    "-";

  const durationUnitText =
    DURATION_UNIT_LIST.find((item) => item.value === order.durationUnit)?.text ||
    "";

  const redeemStatusText = order.redeemStatus ? "Activated" : "Inactivated";
  const orderStatusText = ORDER_STATUS[order.orderStatus] || "Unknown";

  const content = (
    <StyledOrderDetail>
      <Card className="detail-card">
        <CardContent>
          <h3 className="detail-title">Order Detail</h3>
          <div className="detail-grid">
            <div className="detail-item">
              <p className="detail-label">Order Number</p>
              <div className="detail-value">{order.orderNo || "-"}</div>
            </div>
            <div className="detail-item">
              <p className="detail-label">Transaction ID</p>
              <div className="detail-value">{order.transactionId || "-"}</div>
            </div>
            <div className="detail-item">
              <p className="detail-label">Member</p>
              <div className="detail-value">
                {`${order.memberNickName || ""} (${order.memberEmail || "-"})`}
              </div>
            </div>
            <div className="detail-item">
              <p className="detail-label">Product</p>
              <div className="detail-value">
                {`${productName} (${order.productCode || "-"})`}
              </div>
            </div>
            <div className="detail-item">
              <p className="detail-label">Duration</p>
              <div className="detail-value">
                {`${order.duration || 0} ${durationUnitText}`}
              </div>
            </div>
            <div className="detail-item">
              <p className="detail-label">Price</p>
              <div className="detail-value">
                {`$${order.payPrice || 0} ${order.payCurrency || ""}`}
              </div>
            </div>
            <div className="detail-item">
              <p className="detail-label">Payment Method</p>
              <div className="detail-value">
                {PAYMENT_TYPE[order.payment] || "Unknown"}
              </div>
            </div>
            <div className="detail-item">
              <p className="detail-label">Redeem Status</p>
              <div className="detail-value">{redeemStatusText}</div>
            </div>
            <div className="detail-item">
              <p className="detail-label">Order Status</p>
              <div className="detail-value">{orderStatusText}</div>
            </div>
            <div className="detail-item">
              <p className="detail-label">Created Date</p>
              <div className="detail-value">
                {moment(order.createdAt).format("lll")}
              </div>
            </div>
          </div>
        </CardContent>
        <CardActions>
          <Button
            className="detail-close-btn"
            variant="outlined"
            size="medium"
            onClick={() => {
              closeOrderDetail();
            }}
          >
            Close
          </Button>
        </CardActions>
      </Card>
    </StyledOrderDetail>
  );

  return content;
};

export default OrderDetail;
